import React, { useState } from 'react';


const DeletePlaylistModal = ({ isOpen, onClose, onDelete, playlistName }) => {
    // Don't render if modal is not open
    if (!isOpen) return null;

    // Close modal when 'X' or Cancel is clicked
    const handleClose = () => {
        onClose();
    };

    // Confirm delete action
    const handleDelete = () => {
        onDelete(); // Trigger the deletion logic
        onClose(); // Close the modal after deletion
    };

    // Close modal when clicking on overlay
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-container">
                <div className="modal-header">
                    <h2 className="modal-title">Delete Playlist</h2>
                    <button className="modal-close" onClick={handleClose}>
                        ✕
                    </button>
                </div>
                <div className="modal-body">
                    <p>Are you sure you want to delete the playlist "{playlistName}"?</p>
                    <p style={{color: '#e74c3c', fontWeight: 'bold', marginTop: '10px'}}>
                        This action cannot be undone.
                    </p>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={handleClose}>Cancel</button>
                    <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
                </div>
            </div>
        </div>
    );
};

 export default DeletePlaylistModal;
